(() => {
  if (window.__yurinoxDeferredAppAssets) return;
  window.__yurinoxDeferredAppAssets = true;

  const delayedNodes = [];
  const delayedAssetPattern = /appio-reviews\.(min\.)?(js|css)/i;
  const originalAppend = Element.prototype.append;
  const originalAppendChild = Node.prototype.appendChild;

  const nodeUrl = (node) => {
    if (!(node instanceof Element)) return '';
    return node.getAttribute('src') || node.getAttribute('href') || '';
  };

  const shouldDelayNode = (node) => delayedAssetPattern.test(nodeUrl(node));

  const queueDelayedNode = (parent, node) => {
    delayedNodes.push(() => originalAppendChild.call(parent, node));
    return node;
  };

  Element.prototype.append = function (...nodes) {
    const immediateNodes = [];

    for (const node of nodes) {
      if (shouldDelayNode(node)) {
        queueDelayedNode(this, node);
      } else {
        immediateNodes.push(node);
      }
    }

    if (immediateNodes.length) {
      return originalAppend.apply(this, immediateNodes);
    }
  };

  Node.prototype.appendChild = function (node) {
    if (shouldDelayNode(node)) {
      return queueDelayedNode(this, node);
    }

    return originalAppendChild.call(this, node);
  };

  const loadDeferredScripts = (mode) => {
    document.querySelectorAll('script[data-yurinox-defer-app]').forEach((placeholder) => {
      const deferMode = placeholder.dataset.yurinoxDeferApp || 'idle';
      if (placeholder.dataset.yurinoxLoaded === 'true') return;
      if (mode === 'idle' && deferMode === 'interaction') return;

      const src = placeholder.dataset.yurinoxDeferSrc;
      if (!src) return;

      const script = document.createElement('script');
      for (const attribute of placeholder.attributes) {
        if (
          attribute.name === 'type' ||
          attribute.name === 'data-yurinox-defer-app' ||
          attribute.name === 'data-yurinox-defer-src' ||
          attribute.name === 'data-yurinox-original-type'
        ) {
          continue;
        }
        script.setAttribute(attribute.name, attribute.value);
      }

      script.type = placeholder.dataset.yurinoxOriginalType || 'text/javascript';
      script.src = src;
      placeholder.dataset.yurinoxLoaded = 'true';
        placeholder.replaceWith(script);
      });

    while (delayedNodes.length) {
      delayedNodes.shift()();
    }
  };

  const scheduleFallbackLoad = () => {
    setTimeout(() => loadDeferredScripts('interaction'), 12000);
  };

  const loadAll = () => loadDeferredScripts('interaction');
  ['pointerdown', 'keydown', 'touchstart'].forEach((eventName) => {
    window.addEventListener(eventName, loadAll, { once: true, passive: true });
  });

  if (document.readyState === 'complete') {
    scheduleFallbackLoad();
  } else {
    window.addEventListener('load', scheduleFallbackLoad, { once: true });
  }
})();
